import { Injectable } from '@angular/core';
import {environment} from '@env/environment';

@Injectable()
export class AuthRedirectService {

  public goToLogin(): void {
    const redirectUrl = encodeURIComponent(window.location.href);
    window.location.replace(`${environment.authServerUrl}?redirectUrl=${redirectUrl}`);
  }
}
